/**
 * Partners API Service
 * Handles fetching partner data from the CMS
 */

import { api } from '../core/api.client';
import { ApiClientResponse } from '../core/api.types';
import { Partner } from '../../types/partnerType';

export class PartnersApi {
  private readonly endpoint = 'landing-partner';

  /**
   * Get all partners
   */
  async getPartners(): Promise<ApiClientResponse<Partner[]>> {
    return api.get<Partner[]>(this.endpoint);
  }

  /**
   * Get partner by ID
   */
  async getPartnerById(id: string): Promise<ApiClientResponse<Partner>> {
    return api.get<Partner>(`${this.endpoint}/${id}`);
  }
}

// Export singleton instance
export const partnersApi = new PartnersApi();

// Export convenience methods
export const partners = {
  getAll: () => partnersApi.getPartners(),
  getById: (id: string) => partnersApi.getPartnerById(id),
};
